import { getGuideBySlug } from 'data/guides';

export const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://marttong.kr';

export const SITE_NAME = '마트통포스';

export const DEFAULT_OG_IMAGE = `${SITE_URL}/web-app-manifest-512x512.png`;

export type SeoMeta = {
  title: string;
  description: string;
  ogDescription?: string;
  path?: string;
};

export const DEFAULT_SEO: SeoMeta = {
  title: '마트통포스 - 소상공인 마트 전용 POS 프로그램',
  description:
    '30년 노하우 마트통포스. 소상공인 마트 POS·키오스크·CRM. 전국 2,000+ 가맹점, 무료 상담',
  ogDescription:
    '30년 노하우 마트통포스. 소상공인 마트 전용 POS·키오스크·CRM. 전국 2,000+ 가맹점',
};

const ROUTE_SEO: Record<string, SeoMeta> = {
  '/': DEFAULT_SEO,
  '/company': {
    title: '회사소개 - 마트통포스',
    description:
      '동네 슈퍼 디지털화를 선도하는 마트통포스. 30년 POS 개발 전문 (주)러닝랩의 e-Commerce, POS, KIOSK 솔루션을 소개합니다.',
  },
  '/company/greeting': {
    title: '인사말 - 마트통포스',
    description:
      '마트통포스 대표 인사말. 소상공인과 동네 슈퍼의 디지털 혁신을 이끄는 마트통포스의 비전과 약속을 확인하세요.',
  },
  '/company/history': {
    title: '연혁 - 마트통포스',
    description:
      '마트통포스의 성장 역사와 주요 연혁. 30년 POS 사업 노하우로 소상공인 마트 솔루션을 선도해 온 발자취입니다.',
  },
  '/company/map': {
    title: '오시는 길 - 마트통포스',
    description:
      '마트통포스 본사 위치 및 오시는 길. 경기 부천시 춘의테크노파크3차. POS 상담 및 문의 환영합니다.',
  },
  '/product': {
    title: 'POS 프로그램 - 마트통포스',
    description:
      'AI 재고예측, 매입가 동적조정, ESL/POP 제작이 가능한 마트통포스 POS. 슈퍼·마트·편의점·외식업 등 다양한 업종 지원.',
  },
  '/product/kiosk': {
    title: '키오스크 - 마트통포스',
    description:
      '무인·모바일 키오스크 솔루션. 마트통포스 키오스크로 인건비 절감과 매장 운영 효율을 높이세요.',
  },
  '/product/manless': {
    title: '무인매장 원격관리 - 마트통포스',
    description:
      '스마트폰으로 제어하는 무인매장 원격관리 시스템. 실시간 모니터링으로 안정적인 무인매장 운영을 지원합니다.',
  },
  '/product/app': {
    title: '나만의 쇼핑몰 앱 - 마트통포스',
    description:
      '독립 쇼핑몰 운영 앱. 주문·결제·배송·홍보를 모바일로 간편하게. 마트통포스 쇼핑몰 솔루션.',
  },
  '/product/crm': {
    title: 'CRM 모바일전단지 - 마트통포스',
    description:
      'AI 기반 모바일전단지 제작 CRM. 상품 촬영 없이 전단지 제작, 회원 일괄 발송, 실시간 주문 관리까지.',
  },
  '/contact': {
    title: '고객문의 - 마트통포스',
    description:
      '마트통포스 POS 도입 상담 및 고객문의. 전화 02-6952-7652. 소상공인 마트 POS 무료 상담을 신청하세요.',
  },
  '/notice': {
    title: '공지사항 - 마트통포스',
    description:
      '마트통포스 공지사항. POS 업데이트, 이벤트, 서비스 안내 등 최신 소식을 확인하세요.',
  },
  '/guide': {
    title: '매장 운영 가이드 - 마트통포스',
    description:
      '소상공인 마트·슈퍼를 위한 POS 선택, 재고관리, 키오스크·무인매장, ESL·POP, CRM 마케팅 실전 가이드.',
  },
  '/faq': {
    title: '자주 묻는 질문(FAQ) - 마트통포스',
    description:
      '마트통포스 POS·키오스크·ESL·CRM 도입 FAQ. 비용, 데이터 이전, 교육, A/S 등 자주 묻는 질문과 답변.',
  },
  '/privacy': {
    title: '개인정보처리방침 - 마트통포스',
    description:
      '마트통포스 개인정보처리방침. 고객 개인정보 보호 정책 및 처리 방침을 안내합니다.',
  },
};

export const getSeoForPath = (
  pathname: string,
): SeoMeta & { canonical: string } => {
  const normalizedPath = pathname.replace(/\/$/, '') || '/';

  const guideMatch = normalizedPath.match(/^\/guide\/([^/]+)$/);
  if (guideMatch) {
    const guide = getGuideBySlug(guideMatch[1]);
    if (guide) {
      return {
        title: `${guide.title} - 마트통포스`,
        description: guide.description,
        canonical: `${SITE_URL}/guide/${guide.slug}`,
      };
    }
  }

  const seo = ROUTE_SEO[normalizedPath] ?? DEFAULT_SEO;

  return {
    ...seo,
    canonical: `${SITE_URL}${normalizedPath === '/' ? '' : normalizedPath}`,
  };
};

export const PRERENDER_ROUTES = Object.keys(ROUTE_SEO);
